export default {"src":"/_next/static/media/Oval (1).26458e8e.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};